import { Step } from "react-joyride";

export const tourStepsHome = (): Step[] => {
  const steps: Step[] = [
    {
      target: ".hero-section",
      content:
        "Welcome to Race The Clock. This site helps students practice recognition and recall by flashing items at a set speed, then tracking how they do.",
      disableBeacon: true,
    },
    {
      target: ".audience-list",
      content:
        "Teachers, students, and adult learners can all use it. The original goal was 60 letters a minute, and it now works for many subjects.",
    },
    {
      target: ".features-section",
      content:
        "Create collections, set the speed, and run practice sessions. You can also use games, a name spinner, and reports.",
    },
    {
      target: ".features-grid",
      content:
        "These cards summarize the main tools. After you log in, start with Your Collections to make or open a set of items.",
    },
    {
      target: ".coming-soon-section",
      content:
        "This section lists extra ideas. Many of those tools, like Games and the Name Generator, are already in the menu above.",
    },
    {
      target: ".top-navbar-height",
      content:
        "Use the top menu to move around. Log in to save collections. In Settings you can turn this guided tour on or off.",
    },
  ];

  return steps;
};
